package com.fireavert.fire_risk.client.presentation

import com.fireavert.common.TableColumn
import com.fireavert.fire_risk.data_models.TenantFireRiskDataModel

class RiskTableController(
    private val interactor: RiskTableInteractor
) {
    suspend fun onLoad() = interactor.onLoad()

    suspend fun updateData(propertyId: Int?, eventTypeValue: String) = interactor.updateData(
        propertyId,
    )

    fun sortTrackingRecordsByColumn(
        columns: Array<TableColumn>,
        trackingRecords: List<TenantFireRiskDataModel>,
    ): List<TenantFireRiskDataModel> {
        return interactor.sortTrackingRecordsByColumn(columns, trackingRecords)
    }
}